import React from 'react'

const Health = () => {

  return (
    <div >
      <p>Alive</p>
    </div>
  )
}

export default Health